import { type SvgIconProps, SvgIcon } from '@/shared/ui/icons/svg-icon';

export const renderIcon = (options: SvgIconProps) => h(SvgIcon, options);
